import service from "@/api/service";
import { GetResponse } from "@/api/profile-list/response";
import { GetRequest } from "@/api/profile-list/request";

/**
 * プロフィール追加項目情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-profile-list", getRequest);
  return response.data as GetResponse;
}
